// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"781":"c632b2f6","922":"b9bedd30","964":"edc82846","984":"3d4667aa"}[chunkId] + ".chunk.js";
};